export const INVOKE_TOASTER: string = 'invoke_toaster';
export const SET_TOAST: string = 'set_toast';
export const REMOVE_TOAST: string = 'remove_toast';

